import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

import { trackNavigationHeaderClick } from '../../../../shared';

type NavigationItemLabelProps = {
    emphasis?: 'default' | 'promotion';
    href?: string;
    openInNewTab?: boolean;
    title: string;
} & Omit<ComponentPropsWithoutRef<'a'>, 'children' | 'className' | 'href'>;

export function NavigationItemLabel({
    emphasis,
    href,
    openInNewTab,
    title,
    onClick,
    ...props
}: NavigationItemLabelProps) {
    const className = cn('desktop-menu__link', {
        'desktop-menu__link--sale': emphasis === 'promotion',
    });

    if (!href) {
        return (
            <span {...props} className={className}>
                {title}
            </span>
        );
    }

    return (
        <a
            {...props}
            href={href}
            className={className}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            target={openInNewTab ? '_blank' : undefined}
            onClick={event => {
                trackNavigationHeaderClick({ selection: [title], linkUrl: href, navSection: 'main nav' });
                onClick?.(event);
            }}
        >
            {title}
        </a>
    );
}
